import {
  BACKEND_SKILLS,
  FRONTEND_SKILLS,
  BLOCKCHAIN_SKILLS,
  GAME_SKILLS,
} from "./tech-skills";

export const PROJECT_CATEGORY = {
  ALL: "all",
  FULL_STACK: "full-stack",
  GAME: "game",
  BLCOKCHAIN: "blockchain",
  MOST: "most",
};

export const TABS = [
  {
    label: "All",
    value: PROJECT_CATEGORY.ALL,
  },
  {
    label: "Recent",
    value: PROJECT_CATEGORY.MOST,
  },
  {
    label: "Full Stack",
    value: PROJECT_CATEGORY.FULL_STACK,
  },
  {
    label: "Game",
    value: PROJECT_CATEGORY.GAME,
  },
  {
    label: "Blockchain",
    value: PROJECT_CATEGORY.BLCOKCHAIN,
  },
];

const getSkillByLabel = (skills, techLabel) =>
  skills.find(({ label }) => label === techLabel);

export const PROJECTS = [
  {
    imgSrc: "/assets/projects/luxuary.png",
    title: "Luxury Real Estate Platform",
    techIcons: [
      getSkillByLabel(FRONTEND_SKILLS, "HTML"),
      getSkillByLabel(FRONTEND_SKILLS, "CSS"),
      getSkillByLabel(FRONTEND_SKILLS, "Javascript"),
      getSkillByLabel(FRONTEND_SKILLS, "Bootstrap"),
      getSkillByLabel(FRONTEND_SKILLS, "WordPress"),
      getSkillByLabel(BACKEND_SKILLS, "PHP"),
      getSkillByLabel(BACKEND_SKILLS, "Laravel"),
      getSkillByLabel(BACKEND_SKILLS, "MySQL"),
      getSkillByLabel(BACKEND_SKILLS, "RESTful Api"),
    ],
    description: `A platform for browsing luxury properties and accessing a range of related services. It is known for its luxury properties and exceptional service.`,
    repoLink: "",
    sourceLink: "https://www.drumelia.com",
    category: [PROJECT_CATEGORY.ALL],
  },
  // {
  //   imgSrc: "/assets/projects/solkitties.png",
  //   title: "Sol Kitties",
  //   techIcons: [
  //     getSkillByLabel(FRONTEND_SKILLS, "React.js"),
  //     getSkillByLabel(FRONTEND_SKILLS, "Redux"),
  //     getSkillByLabel(FRONTEND_SKILLS, "Tailwind CSS"),
  //     getSkillByLabel(BLOCKCHAIN_SKILLS, "Blockchain"),
  //     getSkillByLabel(BLOCKCHAIN_SKILLS, "Solana"),
  //     getSkillByLabel(BLOCKCHAIN_SKILLS, "Rust"),
  //     getSkillByLabel(BLOCKCHAIN_SKILLS, "Web3"),
  //     getSkillByLabel(BLOCKCHAIN_SKILLS, "Hardhat"),
  //   ],
  //   description: `The Sol Kitties is a Solana project the growing trend of combining NFTs with gaming and virtual worlds, providing users with not just a digital asset, but an immersive experience that can potentially offer rewards through play. `,
  //   repoLink: "",
  //   sourceLink: "https://www.solkitties.net/",
  //   category: [PROJECT_CATEGORY.ALL],
  // },

  {
    imgSrc: "/assets/projects/solnft.png",
    title: "Solana NFT Marketplace",
    techIcons: [
      getSkillByLabel(FRONTEND_SKILLS, "Next.js"),
      getSkillByLabel(BACKEND_SKILLS, "Node.js"),
      getSkillByLabel(BACKEND_SKILLS, "Express (Node.js Framework)"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Blockchain"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Solana"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Rust"),
      getSkillByLabel(FRONTEND_SKILLS, "Tailwind CSS"),
    ],
    description: `This website is a full-stack Solana NFT Marketplace that I've built using Next.js and TypeScript.`,
    repoLink: "",
    sourceLink: "https://sol-nft.fly.dev",
    category: [PROJECT_CATEGORY.ALL],
  },
  {
    imgSrc: "/assets/projects/solvecare.png",
    title: "Solve Care",
    techIcons: [
      getSkillByLabel(FRONTEND_SKILLS, "Javascript"),
      getSkillByLabel(FRONTEND_SKILLS, "WordPress"),
      getSkillByLabel(BACKEND_SKILLS, "PHP"),
      getSkillByLabel(BACKEND_SKILLS, "MySQL"),
      getSkillByLabel(FRONTEND_SKILLS, "BackBone.js"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Blockchain"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Ethereum"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Solidity"),
    ],
    description: `Solve.Care is a website of a global healthcare blockchain technology company that aims to redefine the administration of healthcare and benefits programs`,
    repoLink: "",
    sourceLink: "https://solve.care/",
    category: [PROJECT_CATEGORY.ALL],
  },
  
  {
    imgSrc: "/assets/projects/ultax.png",
    title: "UTX | Decentralized Perpetual Exchange",
    techIcons: [
      getSkillByLabel(FRONTEND_SKILLS, "React.js"),
      getSkillByLabel(FRONTEND_SKILLS, "Next.js"),
      getSkillByLabel(BACKEND_SKILLS, "Node.js"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Blockchain"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Ethereum"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Solidity"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Web3"),
    ],
    description: `UltraX allows trading of top cryptocurrencies like BTC, ETH, and others with up to 50x leverage directly from your wallet.`,
    repoLink: "",
    sourceLink: "https://ultrax.bestsoft.dev/",
    category: [PROJECT_CATEGORY.ALL],
  },

  {
    imgSrc: "/assets/projects/theprimes.png",
    title: "The Primes",
    techIcons: [
      getSkillByLabel(FRONTEND_SKILLS, "Javascript"),
      getSkillByLabel(BACKEND_SKILLS, "Node.js"),
      getSkillByLabel(BACKEND_SKILLS, "Express (Node.js Framework)"),
      getSkillByLabel(BACKEND_SKILLS, "MySQL"),
      getSkillByLabel(BACKEND_SKILLS, "Sequelize"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Blockchain"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Ethereum"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Solidity"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Web3"),
    ],
    description: `The Primes is a project that combines art and technology to redefine the NFT space`,
    repoLink: "",
    sourceLink: "https://www.theprimes.io/",
    category: [PROJECT_CATEGORY.ALL],
  },

  // {
  //   imgSrc: "/assets/projects/eshop.png",
  //   title: "eShop Site",
  //   techIcons: [
  //     getSkillByLabel(FRONTEND_SKILLS, "HTML"),
  //     getSkillByLabel(FRONTEND_SKILLS, "SCSS"),
  //     getSkillByLabel(FRONTEND_SKILLS, "Angular"),
  //     getSkillByLabel(BACKEND_SKILLS, "PHP"),
  //     getSkillByLabel(BACKEND_SKILLS, "Laravel"),
  //     getSkillByLabel(BACKEND_SKILLS, "MySQL"),
  //     getSkillByLabel(BACKEND_SKILLS, "Heroku"),
  //     getSkillByLabel(BACKEND_SKILLS, "RESTful Api"),
  //   ],
  //   description: `A wristband shop site that services ordering and designing the productions. Everyone can order custom silicone wristbands`,
  //   repoLink: "",
  //   sourceLink: "https://www.rapidwristbands.com/",
  //   category: [PROJECT_CATEGORY.ALL],
  // },
  
  {
    imgSrc: "/assets/projects/goatswap.png",
    title: "Goat Swap",
    techIcons: [
      getSkillByLabel(FRONTEND_SKILLS, "Next.js"),
      getSkillByLabel(BACKEND_SKILLS, "Node.js"),
      getSkillByLabel(BACKEND_SKILLS, "Express (Node.js Framework)"),
      getSkillByLabel(BACKEND_SKILLS, "MySQL"),
      getSkillByLabel(FRONTEND_SKILLS, "Tailwind CSS"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Blockchain"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Solana"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Rust"),
    ],
    description: `GOAT Swap is a decentralized platform on the Solana blockchain that offers a permissionless way to trade NFTs. `,
    repoLink: "",
    sourceLink: "https://goatswap.xyz/",
    category: [PROJECT_CATEGORY.ALL],
  },
  {
    imgSrc: "/assets/projects/lunchpad.png",
    title: "Blockchain Metaverse",
    techIcons: [
      getSkillByLabel(FRONTEND_SKILLS, "Javascript"),
      getSkillByLabel(FRONTEND_SKILLS, "Vue.js"),
      getSkillByLabel(FRONTEND_SKILLS, "Tailwind CSS"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Blockchain"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Ethereum"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Solidity"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Web3"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Hardhat"),
    ],
    description: `Next Earth's Launchpad, is part of the Next Earth project, which is a blockchain metaverse initiative.`,
    repoLink: "",
    sourceLink: "https://launchpad.nextearth.io/",
    category: [PROJECT_CATEGORY.ALL],
  },
  {
    imgSrc: "/assets/projects/ecommerce.png",
    title: "e-Commerce Platform",
    techIcons: [
      getSkillByLabel(FRONTEND_SKILLS, "HTML"),
      getSkillByLabel(FRONTEND_SKILLS, "CSS"),
      getSkillByLabel(FRONTEND_SKILLS, "Javascript"),
      getSkillByLabel(FRONTEND_SKILLS, "Bootstrap"),
      getSkillByLabel(BACKEND_SKILLS, "PHP"),
      getSkillByLabel(BACKEND_SKILLS, "MySQL"),
      getSkillByLabel(FRONTEND_SKILLS, "WordPress"),
      getSkillByLabel(FRONTEND_SKILLS, "SEO"),
    ],
    description: `A platform that provides features and Tools for creating and managing an online store.`,
    repoLink: "",
    sourceLink: "https://www.shuup.com/",
    category: [PROJECT_CATEGORY.ALL],
  },
  {
    imgSrc: "/assets/projects/travelerMap.png",
    title: "World Travel Map",
    techIcons: [
      getSkillByLabel(FRONTEND_SKILLS, "Javascript"),
      getSkillByLabel(FRONTEND_SKILLS, "Tailwind CSS"),
      getSkillByLabel(BACKEND_SKILLS, "Node.js"),
      getSkillByLabel(BACKEND_SKILLS, "Express (Node.js Framework)"),
      getSkillByLabel(BACKEND_SKILLS, "PostgreSQL"),
      getSkillByLabel(BACKEND_SKILLS, "RESTful Api"),
      getSkillByLabel(BACKEND_SKILLS, "Elixir"),
      getSkillByLabel(BACKEND_SKILLS, "Heroku"),
    ],
    description: `World Travel Map is an interactive world travel map that allows users to explore national parks around the globe.`,
    repoLink: "",
    sourceLink: "https://travelermap.net/",
    category: [PROJECT_CATEGORY.ALL],
  },
  {
    imgSrc: "/assets/projects/woundcharts.png",
    title: "WoundChart",
    techIcons: [
      getSkillByLabel(FRONTEND_SKILLS, "HTML"),
      getSkillByLabel(FRONTEND_SKILLS, "CSS"),
      getSkillByLabel(FRONTEND_SKILLS, "Javascript"),
      getSkillByLabel(FRONTEND_SKILLS, "React.js"),
      getSkillByLabel(FRONTEND_SKILLS, "Bootstrap"),
      getSkillByLabel(BACKEND_SKILLS, "PHP"),
      getSkillByLabel(BACKEND_SKILLS, "MySQL"),
      getSkillByLabel(BACKEND_SKILLS, "RESTful Api"),
    ],
    description: `Wound Charts is a web-based electronic medical record (EMR) system specifically designed for wound care practice.`,
    repoLink: "",
    sourceLink: "https://woundcharts.com/",
    category: [PROJECT_CATEGORY.ALL],
  },

  // {
  //   imgSrc: "/assets/projects/positionExchange.png",
  //   title: "Position Exchange | DeFi | DEX",
  //   techIcons: [
  //     getSkillByLabel(FRONTEND_SKILLS, "Javascript"),
  //     getSkillByLabel(FRONTEND_SKILLS, "Typescript"),
  //     getSkillByLabel(BLOCKCHAIN_SKILLS, "Blockchain"),
  //     getSkillByLabel(BLOCKCHAIN_SKILLS, "Ethereum"),
  //     getSkillByLabel(BLOCKCHAIN_SKILLS, "Solidity"),
  //     getSkillByLabel(BLOCKCHAIN_SKILLS, "Web3"),
  //     getSkillByLabel(BACKEND_SKILLS, "MySQL"),
  //   ],
  //   description: `Position Exchange is a decentralized trading and exchange platform that aims to provide a transparent, trustless, and fully on-chain trading experience.`,
  //   repoLink: "",
  //   sourceLink: "https://position.exchange/",
  //   category: [PROJECT_CATEGORY.ALL],
  // },

  {
    imgSrc: "/assets/projects/housebuyers.png",
    title: "House Market Project",
    techIcons: [
      getSkillByLabel(FRONTEND_SKILLS, "HTML"),
      getSkillByLabel(FRONTEND_SKILLS, "CSS"),
      getSkillByLabel(FRONTEND_SKILLS, "Javascript"),
      getSkillByLabel(FRONTEND_SKILLS, "Angular"),
      getSkillByLabel(FRONTEND_SKILLS, "Typescript"),
      getSkillByLabel(FRONTEND_SKILLS, "Bootstrap"),
      getSkillByLabel(BACKEND_SKILLS, "Node.js"),
      getSkillByLabel(BACKEND_SKILLS, "Express (Node.js Framework)"),
      getSkillByLabel(BACKEND_SKILLS, "RESTful Api"),
    ],
    description: `A mobile app and web site for buying and selling houses.`,
    repoLink: "",
    sourceLink: "https://www.housebuyersofamerica.com/",
    category: [PROJECT_CATEGORY.ALL],
  },
  {
    imgSrc: "/assets/projects/farmersworld.png",
    title: "First Farming Game",
    techIcons: [
      getSkillByLabel(FRONTEND_SKILLS, "React.js"),
      getSkillByLabel(FRONTEND_SKILLS, "Next.js"),
      getSkillByLabel(BACKEND_SKILLS, "Node.js"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Blockchain"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Ethereum"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Solidity"),
      getSkillByLabel(BLOCKCHAIN_SKILLS, "Web3"),
    ],
    description: `Farmers World is an NFT game. It's a play-to-earn blockchain game that operates on the WAX blockchain platform. `,
    repoLink: "",
    sourceLink: "https://farmersworld.io/",
    category: [PROJECT_CATEGORY.ALL],
  },

  // {
  //   imgSrc: "/assets/projects/",
  //   title: "Live Minting Site",
  //   techIcons: [
  //     getSkillByLabel(FRONTEND_SKILLS, "Typescript"),
  //     getSkillByLabel(FRONTEND_SKILLS, "React.js"),
  //     getSkillByLabel(FRONTEND_SKILLS, "Redux"),
  //     getSkillByLabel(FRONTEND_SKILLS, "Next.js"),
  //     getSkillByLabel(FRONTEND_SKILLS, "Tailwind CSS"),
  //     getSkillByLabel(BLOCKCHAIN_SKILLS, "Blockchain"),
  //     getSkillByLabel(BLOCKCHAIN_SKILLS, "Ethereum"),
  //     getSkillByLabel(BLOCKCHAIN_SKILLS, "Solidity"),
  //     getSkillByLabel(BLOCKCHAIN_SKILLS, "Web3"),
  //     getSkillByLabel(BLOCKCHAIN_SKILLS, "Hardhat"),
  //   ],
  //   description: `Meta Maniac Non-fungible token minting site.`,
  //   repoLink: "",
  //   sourceLink: "https://www.metamaniacsnft.com/",
  //   category: [PROJECT_CATEGORY.ALL],
  // },
  // {
  //   imgSrc: "/assets/projects/",
  //   title: "On-demand Delivery Service",
  //   techIcons: [
  //     getSkillByLabel(FRONTEND_SKILLS, "HTML"),
  //     getSkillByLabel(FRONTEND_SKILLS, "CSS"),
  //     getSkillByLabel(FRONTEND_SKILLS, "Javascript"),
  //     getSkillByLabel(FRONTEND_SKILLS, "Bootstrap"),
  //     getSkillByLabel(FRONTEND_SKILLS, "Gatsby"),
  //     getSkillByLabel(BACKEND_SKILLS, "Node.js"),
  //     getSkillByLabel(BACKEND_SKILLS, "Express (Node.js Framework)"),
  //     getSkillByLabel(BACKEND_SKILLS, "Sequelize"),
  //     getSkillByLabel(BACKEND_SKILLS, "MySQL"),
  //     getSkillByLabel(BACKEND_SKILLS, "RESTful Api"),
  //   ],
  //   description: `A website that provides on-demand delivery services for a variety of products.`,
  //   repoLink: "",
  //   sourceLink: "https://glovoapp.com/",
  //   category: [PROJECT_CATEGORY.ALL],
  // },

  // {
  //   imgSrc: "/assets/projects/",
  //   title: "Travel Service System",
  //   techIcons: [
  //     getSkillByLabel(FRONTEND_SKILLS, "HTML"),
  //     getSkillByLabel(FRONTEND_SKILLS, "CSS"),
  //     getSkillByLabel(FRONTEND_SKILLS, "Javascript"),
  //     getSkillByLabel(FRONTEND_SKILLS, "Bootstrap"),
  //     getSkillByLabel(BACKEND_SKILLS, "PHP"),
  //     getSkillByLabel(BACKEND_SKILLS, "Laravel"),
  //     getSkillByLabel(BACKEND_SKILLS, "MySQL"),
  //     getSkillByLabel(BACKEND_SKILLS, "Graphql"),
  //   ],
  //   description: `A Travel-related service system including hotel, vacatio, flights, and tours.`,
  //   repoLink: "",
  //   sourceLink: "https://www.bestday.com.mx/",
  //   category: [PROJECT_CATEGORY.ALL],
  // },
];
